import {
    getDealVisibility,
    getDealXgId,
    getDealXgVersion,
    getPublishedBy,
    getIsAmdOriginated,
    getPublishedVersion,
    getShowroomWorkflowStatus,
    getActiveDeal,
    getDealerInfoForPdf,
    isFullPageScrollEnabled,
    getPublishedVersionComment,
    getPublishedProposalId,
    isMultiScenarioOfferEnabled,
    getDealerDetails,
    getDealerMMDId,
    getDealerName,
    getDealerPhone,
    getDealerZip,
    getSalesPerson,
    getBuyerInfo,
    getCoBuyerName,
    getTradeIns
} from '@makemydeal/dr-sales-checkin-store';
import { getSalesCheckinBffEndPoint } from '@makemydeal/dr-sales-checkin-ui-utils';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { AdditionalSelectors } from '@makemydeal/activities-request-proposal';
/**
 * App-specific data access the activity needs, injected into the lib via init().
 * Keeps @makemydeal/activities-request-proposal free of any sales-checkin-store import.
 */
export const additionalSelectors: AdditionalSelectors = {
    getDealPdfEndpoint: (state: any) => {
        const dealId = getDealXgId(state);
        const dealVersion = getPublishedVersion(state) ? getPublishedVersion(state) : getDealXgVersion(state);
        const path = `deals/${dealId}/versions/${dealVersion}/pdf-url`;
        return getSalesCheckinBffEndPoint(path);
    },
    getDealProposalEndpoint: (state: any) => {
        const dealXgId = getDealXgId(state);
        return getSalesCheckinBffEndPoint(`deals/${dealXgId}/proposal`);
    },
    getDealersInfo: (state: any) => {
        const address = getDealerDetails(state).address;
        return {
            id: getDealerMMDId(state) ?? 0,
            name: getDealerName(state),
            street: address?.street ?? '',
            city: address?.city ?? '',
            state: address?.state ?? '',
            zip: getDealerZip(state),
            phoneNumber: getDealerPhone(state) || undefined
        };
    },
    getDealVisibility,
    getDealXgVersion,
    getDealXgId,
    getActiveDeal,
    getPublishedVersion,
    getPublishedProposalId,
    getPublishedBy,
    getPublishedVersionComment,
    isOfferCommentsEnabled: (state: any) => featureToggleSelectors.isShowMvOfferCommentsInSalesPresentationEnabled(state),
    getWorkflowStatus: (state: any) => getShowroomWorkflowStatus(state),
    isFullPageScrollEnabled,
    isMultiScenarioOfferEnabled,
    isAmdOriginated: (state: any) => getIsAmdOriginated(state),
    getDealerInfo: (state: any) => getDealerInfoForPdf(state),
    getSalesPerson: (state: any) => getSalesPerson(state),
    getBuyerInfo: (state: any) => getBuyerInfo(state),
    getCoBuyerName: (state: any) => getCoBuyerName(state),
    getTradeIns: (state: any) => getTradeIns(state)
};
